export default {
  modalId: {
    type: String,
    requried: true,
  },
}



// WEBPACK FOOTER //
// ./src/js/util/props/modalId.js